"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiImplBase = void 0;
const R = __importStar(require("ramda"));
const rxjs_1 = require("rxjs");
const main_1 = require("../main");
const convertToNQError_1 = require("../main/util/convertToNQError");
const uuid_1 = require("uuid");
const utils_1 = require("../main/util/utils");
const ApiKeyHeaderName = "X-APIKEY";
const RequestIdParamName = "requestId";
const RequestIndexParamName = "requestIndex";
class ApiImplBase {
    constructor(baseUrl, apiKey, logger, defaultTimeout = null, useRequestId = false, logRetry) {
        this.baseUrl = baseUrl;
        this.apiKey = apiKey;
        this.logger = logger;
        this.defaultTimeout = defaultTimeout;
        this.useRequestId = useRequestId;
        this.logRetry = logRetry;
        logger.info("ApiImplBase", { baseUrl });
    }
    combineUrlParts(part1, part2) {
        const p1 = part1.replace(/\/?$/g, "");
        const p2 = part2.replace(/^\/?/g, "");
        if (R.isEmpty(part1)) {
            return p2;
        }
        if (R.isEmpty(part2)) {
            return p1;
        }
        return `${p1}/${p2}`;
    }
    getApiEndpointUrl(endpointName) {
        const combinedUrl = this.combineUrlParts(this.baseUrl, endpointName);
        const url = new URL(combinedUrl);
        return url;
    }
    retryIsAllowed(retriesCount, requestIndex, err) {
        return (0, main_1.isNqError)(err) && err.scheme == "Ap-Cn-2" && requestIndex < retriesCount;
    }
    requestAsync(url, options) {
        return __awaiter(this, void 0, void 0, function* () {
            this.logger.info("API Fetch Request (async)", options);
            const headers = new Headers();
            if (!R.isNil(options.bodyData)) {
                headers.append("Content-Type", "application/json");
            }
            const useRequestId = options.mode !== "Custom" && this.useRequestId;
            if (options.mode !== "Custom" && !R.isNil(this.apiKey)) {
                headers.append(ApiKeyHeaderName, this.apiKey);
            }
            const retriesCount = useRequestId ? 2 : 0;
            if (useRequestId) {
                url.searchParams.append(RequestIdParamName, (0, uuid_1.v4)());
                url.searchParams.append(RequestIndexParamName, "");
            }
            let requestIndex = 0;
            while (true) {
                if (useRequestId) {
                    url.searchParams.set(RequestIndexParamName, String(requestIndex));
                }
                try {
                    return yield this.requestAsyncWithHeaders(url, options, headers);
                }
                catch (err) {
                    if (!this.retryIsAllowed(retriesCount, requestIndex, err)) {
                        throw err;
                    }
                }
                /* try request again after delay */
                if (!R.isNil(this.logRetry)) {
                    this.logRetry("Retry Request", new Map([["href", url.href]]));
                }
                requestIndex += 1;
                yield (0, utils_1.delay)(300);
            }
        });
    }
    requestAsyncWithHeaders(url, options, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => {
                this.logger.warn("fetchRequest timeout.");
                controller.abort();
            }, options.fetchTimeout);
            const fetchOptions = {
                headers,
                method: options.method,
                body: R.isNil(options.bodyData) ? undefined : JSON.stringify(options.bodyData),
                signal: controller.signal,
                cache: "no-store",
            };
            let response;
            try {
                response = yield fetch(url, fetchOptions);
            }
            catch (err) {
                this.logger.error("API Server request fetch error", err);
                if (err instanceof DOMException) {
                    throw (0, main_1.createNqError)("Ap-Cn-1", "API Request fetch timeout", err.message);
                }
                else if (err instanceof TypeError) {
                    throw (0, main_1.createNqError)("Ap-Cn-2", "API Request fetch timeout", err.message);
                }
                else {
                    throw (0, main_1.createNqError)("Cl-1", "API Request fetch error", err);
                }
            }
            finally {
                clearTimeout(timeoutId);
            }
            if (response.ok) {
                const getValue = (() => {
                    switch (options.mode) {
                        case "Blob": return response.blob();
                        case "Custom": return response.text();
                        case "Default": return response.json();
                    }
                })();
                try {
                    const r = yield getValue;
                    this.logger.debug("fetchRequest value", r);
                    return r;
                }
                catch (err) {
                    this.logger.error("fetchRequest getValue", err);
                    throw (0, main_1.createNqError)("Ap-Re-1", `API Server response is ok but contains invalid ${options.mode === "Blob" ? "BLOB" : "JSON"} data.`, err);
                }
            }
            else {
                this.logger.warn("fetchRequest response is not ok", response.statusText);
                let errorObj;
                try {
                    errorObj = yield response.json();
                    this.logger.warn("Server response is invalid", errorObj);
                }
                catch (err) {
                    this.logger.error("fetchRequest response.json()", err);
                    throw (0, main_1.createNqError)("Ap-Re-3", `API Server response is not ok and contains invalid JSON.`, err);
                }
                const statusObj = errorObj;
                if (R.isNil(errorObj) || R.isNil(statusObj) || R.isNil(statusObj.status)) {
                    throw (0, main_1.createNqError)("Ap-Re-2", `API Server response is not ok and contains unknown object.`, errorObj);
                }
                else {
                    throw (0, convertToNQError_1.statusModelToNqError)(statusObj.status);
                }
            }
        });
    }
    request(url, options) {
        return new rxjs_1.Observable(subscriber => {
            this.requestAsync(url, options)
                .then(r => {
                subscriber.next(r);
                subscriber.complete();
            })
                .catch(err => {
                subscriber.error(err);
            });
        });
    }
    requestRx(endpointName, method, bodyData, fetchTimeout) {
        var _a;
        if (fetchTimeout === void 0) { fetchTimeout = (_a = this.defaultTimeout) !== null && _a !== void 0 ? _a : 30000; }
        const fullUrl = this.getApiEndpointUrl(endpointName);
        return this.request(fullUrl, { method, bodyData, fetchTimeout, mode: "Default" });
    }
    requestBlobRx(endpointName, method, bodyData, fetchTimeout) {
        var _a;
        if (fetchTimeout === void 0) { fetchTimeout = (_a = this.defaultTimeout) !== null && _a !== void 0 ? _a : 30000; }
        const fullUrl = this.getApiEndpointUrl(endpointName);
        return this.request(fullUrl, { method, bodyData, fetchTimeout, mode: "Blob" });
    }
    customRequestRx(fullUrl, method, fetchTimeout) {
        var _a;
        if (fetchTimeout === void 0) { fetchTimeout = (_a = this.defaultTimeout) !== null && _a !== void 0 ? _a : 30000; }
        return this.request(new URL(fullUrl), { method, fetchTimeout, mode: "Custom" });
    }
}
exports.ApiImplBase = ApiImplBase;
//# sourceMappingURL=ApiImplBase.js.map